import React, { useState } from "react";
import PropTypes from "prop-types";
import ComboBox from "../../../common/ComboBox";

const Priorities = ({ defaultConfigs, orderOptions, onChange }) => {
  const [configs, setConfigs] = useState(defaultConfigs);

  const handleChangeOrder = (configId, value) => {
    let _newConfigs = configs.map((c) => {
      if (c._id !== configId) return c;
      c.order = value;
      return c;
    });

    onChange(_newConfigs);
  };

  return (
    <div className="admin-lp-hb-manage-priorities-form-manage-list">
      {configs?.map((c, cIndex) => {
        return (
          <div className="admin-lp-hb-manage-priorities-form-manage-list-item">
            <ComboBox
              name={`order-${cIndex}`}
              options={orderOptions}
              placeholder={"Order"}
              defaultValue={c.order}
              onChange={(value) => handleChangeOrder(c._id, value)}
            />
            <div className="admin-lp-hb-manage-priorities-form-manage-list-item__work">
              {c.work?.name}
            </div>
            <div className="admin-lp-hb-manage-priorities-form-manage-list-item__price">
              {parseFloat(c.price).toLocaleString()}
            </div>
          </div>
        );
      })}
    </div>
  );
};

Priorities.propTypes = {};

export default Priorities;
